<template>
  <div class="">
    <div class="my-4 flex justify-between items-center font-medium">
      <div class="flex rounded-md shadow-sm">
        <div class="relative flex-grow focus-within:z-10">
          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <MagnifyingGlassIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            v-model="filters['global']"
            name="desktop-search-candidate"
            id="desktop-search-candidate"
            class="w-full rounded-none rounded-l-md border-0 py-1.5 pl-10 text-sm leading-6 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
            placeholder="Filter"
          />
        </div>
        <button type="button" class="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50" @click="clearFilter()">
          <XMarkIcon class="-ml-0.5 h-5 w-5 text-gray-400" aria-hidden="true" />
          Clear
        </button>
      </div>
      <div>
        <Button v-tooltip.top="'Expand/Collapse all'" icon="pi pi-arrows-v" @click="toggleExpand" size="small" severity="secondary" class="mr-2" />
        <Button icon="pi pi-plus" label="Add Category" @click="onNewNode" size="small" />
      </div>
    </div>
    <TreeTable v-model:filters="filters" v-model:expanded-keys="treeExpandedKeys" filterMode="strict" :value="treeCategories" size="small" sortField="name" :sortOrder="1" removableSort>
      <Column field="name" header="Name" :expander="true" sortable class="flex items-center">
        <template #body="slotProps">
          <div class="flex items-center py-2 w-2/3">
            <mdicon v-tooltip.top="'Move to ...'" @click="(event) => onMoveNode(slotProps?.node, event)" name="drag" size="16" class="text-slate-400 mr-0.5 hover:text-slate-700 cursor-pointer"></mdicon>
            <div :class="[getNodeTitleClass(slotProps?.node), 'hover:underline cursor-pointer truncate']" @click="onEditNode(slotProps?.node)">{{ slotProps?.node?.data?.name }}</div>
            <mdicon
              v-if="slotProps.node.level < 2"
              v-tooltip.top="'Add subcategory ...'"
              @click="onNewNode(slotProps?.node)"
              name="plus"
              size="16"
              class="text-slate-400 ml-1 hover:text-slate-700 cursor-pointer"
              aria-hidden="true"
            ></mdicon>
          </div>
        </template>
      </Column>
      <Column field="description" header="Description" style="width: 50%">
        <template #body="slotProps">
          <div class="truncate">{{ slotProps?.node?.data?.description }}</div>
        </template>
      </Column>
      <Column style="width: 10%">
        <template #body="slotProps">
          <div class="flex flex-wrap gap-2 justify-end">
            <Button type="button" icon="pi pi-ellipsis-v" rounded severity="secondary" @click="(event) => toggleCategoryMenu(event, slotProps?.node)" size="small" />
          </div>
          <!--
          <div class="flex flex-wrap gap-2 justify-end">
            <Button type="button" v-tooltip.top="'Move to ...'" icon="pi pi-arrows-alt" rounded severity="secondary" @click="(event) => onMoveNode(slotProps?.node, event)" size="small" />
            <Button type="button" v-tooltip.top="'Edit'" icon="pi pi-pencil" rounded severity="secondary" @click="onEditNode(slotProps?.node)" size="small" />
            <Button type="button" v-tooltip.top="'Delete'" icon="pi pi-minus" rounded severity="secondary" @click="onDeleteNode(slotProps?.node)" size="small" />
            <Button type="button" v-tooltip.top="'Add category'" icon="pi pi-plus" rounded severity="secondary" @click="onNewNode(slotProps?.node)" size="small" />
          </div>
          -->
        </template>
      </Column>
      <!--
      <template #footer>
        <div class="flex justify-content-start">
          <Button icon="pi pi-refresh" label="Reload" severity="warning" size="small" />
        </div>
      </template>
      -->
    </TreeTable>
    <CategoriesDialogEditCategory ref="categoryEditDialog" @save="onSaveCategory" />
    <OverlayPanel ref="treeSelectOverlay">
      <div class="text-sm pb-2 border-b border-gray-200">Select new parent</div>
      <Tree :value="moveAvailableTargets" :expanded-keys="{ root: true }" selectionMode="single" :metaKeySelection="false" @nodeSelect="onMoveTargetSelect" class="w-full"></Tree>
    </OverlayPanel>
    <Dialog v-model:visible="treeSelectDialogVisible" modal :header="`Move Category ${moveNode?.label || ''}`" :style="{ width: '40%' }">
      <div class="text-sm mb-2">Select new parent category</div>
      <div class="w-full border border-gray-300 rounded-lg mb-2">
        <Tree
          :value="moveAvailableTargets"
          :expanded-keys="{ root: true }"
          selectionMode="single"
          :metaKeySelection="false"
          @nodeSelect="
            (n) => {
              moveSelectedTargetNode = n;
            }
          "
          class="w-full md:w-30rem"
        ></Tree>
      </div>
      <div class="flex justify-end gap-2">
        <Button type="button" label="Cancel" size="small" severity="secondary" @click="treeSelectDialogVisible = false"></Button>
        <Button
          type="button"
          size="small"
          label="Move"
          :disabled="!moveSelectedTargetNode"
          @click="
            () => {
              onMoveTargetSelect(moveSelectedTargetNode);
              treeSelectDialogVisible = false;
            }
          "
        ></Button>
      </div>
    </Dialog>
    <Menu ref="categoryMenu" id="overlay_menu" :model="categoryMenuItems" :popup="true">
      <template #item="{ item, props }">
        <a v-if="!item.hidden" class="flex items-center" v-bind="props.action">
          <mdicon :name="item.icon" size="18" class="text-slate-400 mr-0.5"></mdicon>
          <span class="ml-2">{{ item.label }}</span>
        </a>
      </template>
    </Menu>
    <ConfirmDialog group="delCat">
      <template #message="slotProps">
        <div class="flex flex-col gap-2">
          <div class="text-sm">Please confirm deleting category</div>
          <div class="text-lg font-medium">{{ currentCategoryNode.label }}</div>
          <div v-if="delNodeHasChildren" class="mt-4">
            <div class="text-sm">
              This category has children.<br />
              Enable to delete child categories as well.
            </div>
            <InputSwitch v-model="delNodeDeleteChildren" />
          </div>
        </div>
      </template>
    </ConfirmDialog>
  </div>
</template>

<script setup>
  import { computed, ref, reactive } from 'vue';
  import { useCategoriesStore } from '@/store/CategoriesStore';
  import { CAT_TYPE_DEFS } from '@/spec/CategoriesTypeDefs';
  import { getUUID } from '@enegelai/core';
  import TreeTable from 'primevue/treetable';
  import Column from 'primevue/column';
  import Button from 'primevue/button';
  import OverlayPanel from 'primevue/overlaypanel';
  import Tree from 'primevue/tree';
  import ConfirmDialog from 'primevue/confirmdialog';
  import { useConfirm } from 'primevue/useconfirm';
  import Menu from 'primevue/menu';
  import Dialog from 'primevue/dialog';
  import InputSwitch from 'primevue/inputswitch';
  import CategoriesDialogEditCategory from '@/components/Categories/editors/CategoriesDialogEditCategory.vue';
  import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/20/solid';
  import { FilterMatchMode } from 'primevue/api';
  import InputText from 'primevue/inputtext';

  const treeSelectOverlay = ref(null);
  const treeSelectDialogVisible = ref(false);
  const categoryEditDialog = ref(null);
  const categoryMenu = ref(null);

  const categoriesStore = useCategoriesStore();
  const confirm = useConfirm();

  const propsDefs = CAT_TYPE_DEFS['standard']?.propsByName || {};

  // Categories object
  const specCategories = computed(categoriesStore.getCatSpecPropGetSet('categories'));

  // Categories in tree table format
  const treeCategories = computed(() => treeFromCategories(specCategories.value));
  // All expanded nodes in a tree
  const treeExpandedKeys = ref({});
  // map key -> category for easier navigation
  let treeKeymap = {};

  // Filters
  const filters = ref({ global: '' });
  const onSetFilter = (value) => {
    filters.value = { global: value };
  };
  const clearFilter = () => {
    filters.value = { global: '' };
  };

  // Data for moving node in tree
  const moveNode = ref(null);
  const moveAvailableTargets = ref(null);
  const moveSelectedTargetNode = ref(null);

  // Data for deleting node in tree
  const delNodeHasChildren = ref(false);
  const delNodeDeleteChildren = ref(false);

  // Data for menu
  const currentCategoryNode = ref(null);

  const categoryMenuItems = ref([
    {
      label: 'Add Subcategory',
      icon: 'plus',
      command: () => {
        onNewNode(currentCategoryNode.value);
      },
    },
    {
      label: 'Move',
      icon: 'drag',
      command: () => {
        onMoveNode(currentCategoryNode.value, null);
      },
    },
    {
      label: 'Edit',
      icon: 'playlist-edit',
      command: () => {
        onEditNode(currentCategoryNode.value, null);
      },
    },
    {
      label: 'Delete',
      icon: 'minus',
      command: () => {
        delNodeHasChildren.value = Array.isArray(currentCategoryNode.value?.children) && currentCategoryNode.value.children.length > 0;
        delNodeDeleteChildren.value = false;
        confirm.require({
          group: 'delCat',
          header: `Delete Category`,
          acceptIcon: 'pi pi-check',
          rejectIcon: 'pi pi-times',
          rejectClass: 'p-button-outlined p-button-sm',
          acceptClass: 'p-button-sm p-button-danger',
          rejectLabel: 'Cancel',
          acceptLabel: 'Delete',
          accept: () => {
            //const newCatId = categoriesStore.cloneCatInPlace(categoriesCloneName.value);
            onDeleteNode(currentCategoryNode.value, delNodeDeleteChildren.value);
          },
          reject: () => {
            console.log(`Category delete canceled`);
          },
        });
      },
    },
  ]);

  function toggleCategoryMenu(event, node) {
    currentCategoryNode.value = node;
    categoryMenuItems.value[0].hidden = node.level < 2 ? false : true;
    categoryMenu.value.toggle(event);
  }

  function toggleExpand() {
    if (Object.keys(treeExpandedKeys.value).length === 0) {
      const expKeys = {};
      Object.values(treeKeymap).map((entry) => {
        if (Array.isArray(entry?.node?.children) && entry.node.children.length > 0) {
          expKeys[entry.node.key] = true;
        }
      });
      treeExpandedKeys.value = expKeys;
    } else {
      treeExpandedKeys.value = {};
    }
  }

  // convert categories to tree
  function treeFromCategories(categoriesRoot) {
    console.log(`Recalculating tree from categories ...`);
    treeKeymap = {};
    if (!Array.isArray(categoriesRoot) || categoriesRoot.length === 0) {
      return [];
    }
    function convertToTreeNode(inputNode, idx, parentKey, parentPath = []) {
      const { categories, ...rest } = inputNode;
      const path = parentPath.concat([idx]);
      const treeNode = {
        key: inputNode?.id || getUUID(),
        icon: 'pi pi-folder',
        label: inputNode?.name || 'Category Name',
        data: inputNode, //rest,
        level: parentPath.length,
        path: path,
      };
      if (categories && categories.length > 0) {
        treeNode.children = categories.map((n, i) => {
          return convertToTreeNode(n, i, treeNode.key, path);
        });
      }
      treeKeymap[treeNode.key] = {
        node: treeNode,
        parentKey: parentKey,
        path: path,
      };
      return treeNode;
    }
    return categoriesRoot.map((n, i) => {
      return convertToTreeNode(n, i, null, []);
    });
  }

  function filterTreeNodes(inputNode, filterKey, maxLevel = 2) {
    const treeNode = {
      key: inputNode.key,
      icon: 'pi pi-folder',
      label: inputNode?.label || 'Category Name',
    };
    if (inputNode.level >= maxLevel) {
      return null;
    }
    const children = inputNode?.children || null;
    if (children && children.length > 0) {
      treeNode.children = children
        .filter((x) => x.key !== filterKey)
        .map((n) => {
          return filterTreeNodes(n, filterKey);
        })
        .filter((x) => x !== null);
    }
    return treeNode;
  }

  function filterTreeExcludeKey(excludeKey) {
    return treeCategories.value
      .filter((x) => x.key !== excludeKey)
      .map((n) => {
        return filterTreeNodes(n, excludeKey);
      })
      .filter((x) => x !== null);
  }

  // convert tree to categories - ?
  function treeToCategories() {
    // +++
  }

  function onMoveNode(node, event) {
    moveNode.value = node;
    moveSelectedTargetNode.value = null;
    moveAvailableTargets.value = [
      {
        key: 'root',
        label: 'Root',
        icon: 'pi pi-folder',
        children: filterTreeExcludeKey(node.key),
      },
    ];
    if (event) {
      treeSelectOverlay.value.toggle(event);
    } else {
      treeSelectDialogVisible.value = true;
    }
  }

  function onMoveTargetSelect(targetNode) {
    treeSelectOverlay.value.hide();
    if (!moveNode.value || !targetNode) {
      return;
    }
    const sourcePath = treeKeymap[moveNode.value.key].path;
    const targetPath = targetNode.key === 'root' ? null : treeKeymap[targetNode.key].path;
    if (!Array.isArray(sourcePath)) {
      console.error(`Invalid source path`, sourcePath, targetPath);
      return;
    }
    console.log(`Moving ${moveNode.value.key} => ${targetNode.key}`);

    // Step 1: Get the parent of the node to move
    const sourceParent = sourcePath.slice(0, -1).reduce((acc, idx) => acc.categories[idx], categoriesStore.catSpec);

    // Step 2: Get the target parent node
    const targetParent = targetPath
      ? targetPath.reduce((acc, idx) => {
          // Ensure the categories array exists at each level
          if (!acc.categories) acc.categories = [];
          return acc.categories[idx];
        }, categoriesStore.catSpec)
      : categoriesStore.catSpec;

    if (!sourceParent || !targetParent) {
      console.error(`Invalid source or target parent`, sourceParent, targetParent);
      return;
    }

    // Step 3: Ensure target parent has a categories array
    if (!targetParent.categories) targetParent.categories = [];

    // Step 4: Remove the node from its current parent's categories
    const [nodeToMove] = sourceParent.categories.splice(sourcePath[sourcePath.length - 1], 1);

    // Step 5: Add the node to the target parent's categories
    targetParent.categories.push(nodeToMove);
    categoriesStore.setChanged();
  }

  function onEditNode(treeNode) {
    if (!treeNode?.data || !categoryEditDialog.value) {
      return;
    }
    console.log('EDIT:', treeNode?.data);
    const breadcrumbs = getNodeBreadcrumbs(treeNode);
    categoryEditDialog.value.start(treeNode.data, treeNode.key, null, null, breadcrumbs);
  }

  function onDeleteNode(treeNode, deleteChildren = false) {
    const targetNode = treeKeymap[treeNode.key].node;
    const targetPath = treeKeymap[treeNode.key].path;
    if (!targetNode || !Array.isArray(targetPath)) {
      console.error(`Invalid target path`, targetPath);
      return;
    }
    if (Array.isArray(targetNode.children) && targetNode.children.length > 0) {
      if (!deleteChildren) {
        // Move children up one level
        const childrenCategories = targetNode.children.map((x) => x.data);
        const parentPath = targetPath.slice(0, -1);
        const parent = parentPath.length > 0 ? parentPath.reduce((acc, idx) => acc.categories[idx], categoriesStore.catSpec) : categoriesStore.catSpec;
        parent.categories = parent.categories.concat(childrenCategories);
      }
    }
    deleteCategoryAtPath(targetPath);
  }

  function getNodeBreadcrumbs(treeNode) {
    if (!treeNode || !Array.isArray(treeNode.path) || treeNode.path.length < 1) {
      return [];
    }
    return getBreadcrumbsFromPath(treeNode.path.slice(0, -1));
  }

  function getBreadcrumbsFromPath(path) {
    let breadcrumbsPath = [];
    path.reduce((acc, idx) => {
      breadcrumbsPath.push({ label: acc[idx].label });
      return acc[idx].children;
    }, treeCategories.value);
    return breadcrumbsPath;
  }

  function setCategoryAtPath(path, newValue) {
    try {
      path.slice(0, -1).reduce((acc, idx) => acc.categories[idx], categoriesStore.catSpec).categories[path[path.length - 1]] = newValue;
    } catch (e) {
      console.error(`Error setting category at path:`, path, newValue, e);
    }
    categoriesStore.setChanged();
  }

  function getCategoryAtPath(path) {
    try {
      return path.reduce((acc, idx) => acc.categories[idx], categoriesStore.catSpec);
    } catch (e) {
      console.error(`Error getting category at path:`, path, e);
      return null;
    }
  }

  function deleteCategoryAtPath(path) {
    try {
      path
        .slice(0, -1)
        .reduce((acc, idx) => acc.categories[idx], categoriesStore.catSpec)
        .categories.splice(path[path.length - 1], 1);
    } catch (e) {
      console.error(`Error deleting category at path`, path, e);
    }
    categoriesStore.setChanged();
  }

  function addCategoryAtPath(path, category) {
    try {
      let parent = categoriesStore.catSpec;
      if (Array.isArray(path) && path.length > 0) {
        parent = path.reduce((acc, idx) => acc.categories[idx], categoriesStore.catSpec);
      }
      if (!('categories' in parent)) {
        parent.categories = [];
      }
      parent.categories.push(category);
    } catch (e) {
      console.error(`Error adding category at path`, path, e);
    }
    categoriesStore.setChanged();
  }

  function onNewNode(parentNode = null) {
    let breadcrumbs = [];
    if (parentNode) {
      breadcrumbs = getBreadcrumbsFromPath(treeKeymap[parentNode.key]?.path || []);
    }
    categoryEditDialog.value.start({}, null, parentNode ? parentNode.key : null, parentNode ? parentNode.label : null, breadcrumbs);
  }

  function onSaveCategory(updatedCategory, key, parentKey = null) {
    if (!key) {
      // add new category
      addCategoryAtPath(parentKey ? treeKeymap[parentKey].path : null, updatedCategory);
      return;
    }

    // update existing category
    const keyInfo = treeKeymap[key] || null;
    if (!keyInfo) {
      console.error(`SAVE: key=${key} not found`, updatedCategory, key);
      return;
    }
    // merged category
    const mergedCategory = Object.assign({}, keyInfo.node.data, updatedCategory);
    setCategoryAtPath(keyInfo.path, mergedCategory);
    console.log(`SAVE:`, updatedCategory, key);
  }

  function getNodeTitleClass(node) {
    if (node?.level === 0) {
      return 'font-semibold';
    } else if (node?.level === 1) {
      return 'font-medium';
    } else {
      return 'font-normal';
    }
  }
</script>
<style></style>
